import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=16467fdf&scoped=true&"
import script from "./UserForm.vue?vue&type=script&lang=js&"
export * from "./UserForm.vue?vue&type=script&lang=js&"
import style0 from "./UserForm.vue?vue&type=style&index=0&id=16467fdf&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16467fdf",
  null
  
)

/* custom blocks */
import block0 from "./UserForm.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16467fdf')) {
      api.createRecord('16467fdf', component.options)
    } else {
      api.reload('16467fdf', component.options)
    }
    module.hot.accept("./UserForm.vue?vue&type=template&id=16467fdf&scoped=true&", function () {
      api.rerender('16467fdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserForm.vue"
export default component.exports